import type { ExpressionType, WorkflowActionArgumentDTO } from '../workflow.types';

export class WorkflowActionArgumentModel {
  private readonly _dto: WorkflowActionArgumentDTO;

  constructor(dto: WorkflowActionArgumentDTO) {
    this._dto = dto;
  }

  get originDTO(): WorkflowActionArgumentDTO {
    return this._dto;
  }

  get argumentName(): string {
    return this._dto.argumentName;
  }

  get expression(): string | undefined {
    return this._dto.expression;
  }

  get expressionType(): ExpressionType | undefined {
    return this._dto.expressionType;
  }

  get id(): string | undefined {
    return this._dto.id;
  }
}
